import "./landing.scss";
import { useNavigate } from "react-router-dom";

// images
import { images } from "../../constants/images";

// component
import LandingNavbar from "../../components/Navbar/LandingNavbar/LandingNavbar";
import NavDrawer from "../../components/NavDrawer/NavDrawer";


const Landing = () => {
  const navigate = useNavigate()
  return (
    <div className="landing">
      <NavDrawer/>
      <LandingNavbar />
      <div className="content">
        <img src={images.landing_bg} alt="Landing" />
        <div className="contentHolder">
          <div className="container">
            <div className="heroBanner">
              <span className="heroTitle">
                Get the Human Factors right in your
              </span>
              <span className="heroTitle">AI-based system</span>
              <span className="heroSubTitle">
                Move closer to compliance with aviation Human Factors
                <br />
                regulations
              </span>
              <button className="startnow"
              onClick={() =>{
                navigate('/auth/signin')
              }}
              > 
                Start now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default Landing;
